import React from 'react';
import CreatableSelect from 'react-select/creatable';

import CommonImage from '@/components/CommonImage';

const CreateIssueSidebar = () => {
	return (
		<div className="example position-relative">
			<div className="example-header">
				<h3>Create an issue</h3>
			</div>
			<div className="create-issue-sidebar bg-white shadow-8dp  position-absolute top-0 right-0">
				<div className="create-issue-sidebar-header d-flex justify-content-between align-items-center">
					<h3 className="semibold-16 mb-0">Create an issue</h3>
					<CommonImage className="cursor-pointer" alt="close" src="/icons/close.svg" />
				</div>
				<div className="create-issue-sidebar-body">
					<div className="row">
						<div className="col-md-12">
							<div className="form-group">
								<div className="sort-button">
									<label className="w-auto semibold-14 gray_dark_02" htmlFor="issue-type">
										Issue Status :
									</label>
									<select
										id="issue-type"
										name="sort"
										className="border-0 bg-transparent py-0 w-auto"
									>
										<option value="Newest">Newest first</option>
										<option value="Oldest">Oldest first</option>
										<option value="Last Modified">Last modified</option>
									</select>
								</div>
							</div>
						</div>
						<div className="col-md-12">
							<div className="upload-img mb-2 d-flex justify-content-start align-items-start">
								<div className="file-uploader height-100 upload-design-image mb-4 mb-sm-0">
									<label className="drag-upload m-0" htmlFor="drag-upload" />
									<input
										accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
										className="file-upload"
										name="image"
										type="file"
										id="drag-upload"
									/>
								</div>
								<div className="upload-img-preview position-relative ml-2">
									<img src="/images/4.jpg" alt="edit" />
									<div className="action-icon position-absolute top-2 right-2 cursor-pointer">
										<CommonImage width="20px" src="/icons/delete_gray.svg" alt="check" />
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group no-shadow-react-select">
								<label htmlFor="collection">Where are you facing the issues?*</label>
								<CreatableSelect
									isMulti
									value={'TEST'}
									onChange={() => {}}
									options={[
										{ label: '01', value: 'Test', id: 1 },
										{ label: '02', value: 'Test1', id: 2 },
										{ label: '03', value: 'Test2', id: 3 }
									]}
									isClearable
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor="collection">Issue details*</label>
								<textarea rows="1" />
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group no-shadow-react-select">
								<label htmlFor="collection">Responsible Person to solve this issue*</label>
								<CreatableSelect
									isMulti
									value={'TEST'}
									onChange={() => {}}
									options={[
										{ label: '01', value: 'Test', id: 1 },
										{ label: '02', value: 'Test1', id: 2 },
										{ label: '03', value: 'Test2', id: 3 }
									]}
									isClearable
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group no-shadow-react-select">
								<label htmlFor="collection">Notify to</label>
								<CreatableSelect
									isMulti
									value={'TEST'}
									onChange={() => {}}
									options={[
										{ label: '01', value: 'Test', id: 1 },
										{ label: '02', value: 'Test1', id: 2 },
										{ label: '03', value: 'Test2', id: 3 }
									]}
									isClearable
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="custom-radio-box custom-radio mb-12">
								<div className="form-group d-flex align-items-center">
									<input type="radio" id="NITEX_DEVELOPMENT" name="" />
									<label for="NITEX_DEVELOPMENT" class="ml-2 mb-0 gray_dark_01 regular-14">
										Need redevelopment
									</label>
								</div>
							</div>
						</div>
						<div className="col-md-12">
							<div className="custom-radio-box custom-radio mb-12">
								<div className="form-group d-flex align-items-center">
									<input type="radio" id="NITEX_DEVELOPMENT2" name="" />
									<label for="NITEX_DEVELOPMENT2" class="ml-2 mb-0 gray_dark_01 regular-14">
										Rework needed
									</label>
								</div>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group no-shadow-react-select">
								<label htmlFor="collection">Notify to</label>
								<CreatableSelect
									isMulti
									value={'TEST'}
									onChange={() => {}}
									options={[
										{ label: '01', value: 'Test', id: 1 },
										{ label: '02', value: 'Test1', id: 2 },
										{ label: '03', value: 'Test2', id: 3 }
									]}
									isClearable
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="custom-chekbox">
								<div className="form-group">
									<input
										type="checkbox"
										id="s"
										name=""
										value=""
										className="custom-checkbox-input"
									/>
									<label
										className="regular-14 d-flex gray_dark_02 align-items-center"
										htmlFor="s"
									>
										<span>Hold this techpack until this issue is solved</span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CreateIssueSidebar;
